import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import EditDraft from '@/images/EditDraft.svg';
import { getItemPresenterTypeAndLabels } from '@/utils/utils';
import { LibraryItem } from '@d-id/types';
import { useTheme } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import mixpanel from 'mixpanel-browser';
import { ListItemIcon, ListItemText } from './components';

interface Props {
    video: LibraryItem;
    onEdit: (video: LibraryItem) => void;
    closeMenu: () => void;
}

export const EditMenuItem = ({ video, onEdit, closeMenu }: Props) => {
    const theme = useTheme();

    if (!video.is_editable) {
        return null;
    }

    return (
        <MenuItem
            disabled={video.is_default}
            onClick={() => {
                onEdit(video);
                mixpanel?.track('options-edit', {
                    event: 'click',
                    videoId: video?.id,
                    ...getItemPresenterTypeAndLabels(video as LibraryItem),
                });
                closeMenu();
            }}>
            <ListItemIcon>
                <MaskedIcon src={EditDraft} size="24px" color={theme.colors.secondary.main} />
            </ListItemIcon>
            <ListItemText>Edit</ListItemText>
        </MenuItem>
    );
};
